
import {AiFillGithub} from 'react-icons/ai'
import {IoLogoFacebook} from 'react-icons/io'
import {IoLogoTwitter} from 'react-icons/io'
import {FaLinkedinIn} from 'react-icons/fa'

const data = [   
    {id: 1, link: 'https://www.linkedin.com/in/donald-madangure-314838ba/', icon: <FaLinkedinIn />}, 
    {id: 2, link: 'https://twitter.com', icon: <IoLogoTwitter />},
    {id: 3, link: 'https://www.facebook.com', icon: <IoLogoFacebook/>},
    {id: 4, link: 'https://github.com/donald-madangure', icon: <AiFillGithub/>},    
]

export default data